import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  mode: '',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'Home',
      component: () => import('@/views/home/Index.vue'),
    },
    {
      path: '/about',
      name: 'About AECS',
      component: () => import('@/views/about/Index.vue'),
    },
    {
      path: '/fees',
      name: 'Fees',
      component: () => import('@/views/fees/Index.vue'),
    },
    {
      path: '/contact',
      name: 'Contact',
      component: () => import('@/views/contact/Index.vue'),
    },
  ],
})
